"use client";

/** The one bit of the header that needs client JS — everything else in
 *  layout.tsx is a Server Component and can't carry an onClick. */
export function LogoutButton() {
  return (
    <button
      onClick={async () => {
        await fetch("/api/auth/logout", { method: "POST" });
        window.location.href = "/login";
      }}
      className="text-xs text-slate-400 underline-offset-2 hover:text-slate-700 hover:underline"
    >
      Log out
    </button>
  );
}
